export default {
  config: {
    data_table_expire_days: 366,
  },
  tags: ["limited-to-cloud"],
  api: [
    { rule: "lcagent.create", allow: false },
    { rule: "lcagent.update", allow: false },
    { rule: "lcagent.delete", allow: false },
    { rule: "lcgroup.create", allow: false },
    { rule: "lcgroup.update", allow: false },
    { rule: "lcgroup.delete", allow: false },
    { rule: ".*", allow: true },
  ],
  page: [
    { rule: "getstarted/.*", allow: false },
    { rule: "dashboard/resources", allow: false },
    { rule: "dashboard/.*", allow: true },
    { rule: "settings/blocklists", allow: false },
    { rule: "settings/sensors", allow: false },
    { rule: "settings/subnets", allow: false },
    { rule: "settings/tags", allow: false },
    { rule: "settings/.*", allow: true },
    { rule: "reporting/.*", allow: true },
    { rule: "blumiraagent/.*", allow: true },
    { rule: "user/.*", allow: true },
  ],
};
